import { Badge, Link, Stack, Td, Tr, useMediaQuery } from '@chakra-ui/react';
import TableCustom from '../../../components/pages/CandidateArea/Table';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRequestDetailResources } from '../../../services/hooks/Resources/useRequestDetailResources';
import MainCard from '../../../components/MainCard/Index';
import { useEffect } from 'react';
import { TextL, TextXS } from '../../../components/Text/Index';
import { badgeColor } from '../../../utils/badgeFunction';
import { useRequestNewResource } from '../../../services/hooks/Resources/useGetRequestNewResource';
import ResourceDetailMobilePage, { IGenericResources } from './mobile/detail';
import { IResourceItem } from './mobile/detail/cardDetail';
import MessageForUser from '../../../components/pages/SelectiveProcess/MessageForUser';

const ResourceSolicitation: React.FC = () => {
  const [isMobile] = useMediaQuery('(max-width: 1024px)');

  const headerResources = ['RECURSO', 'QUESTÃO', 'DATA DO RECURSO', 'SITUAÇÃO', 'AÇÕES'];
  const headerResourcesNoQuestion = ['RECURSO', 'DATA DO RECURSO', 'SITUAÇÃO', 'AÇÕES'];
  const navigate = useNavigate();

  const resourceId = useLocation().pathname.split('/')[4];
  const { data, isLoading } = useRequestDetailResources(resourceId);
  const resourceData = useRequestNewResource(resourceId);

  useEffect(() => {
    if (!resourceId) navigate(-1);
  }, []);

  const listResources: IResourceItem[] | undefined = data?.resource_by_candidate?.map((item) => ({
    id: item.resource_id,
    status: item.status,
    code: item.resource_code,
    proofSubject: item.proof_subject,
    createdAt: item.resource_created_at,
    question: item.question,
  }));

  const isUpdateOrDelete = data?.is_in_resource && data?.has_update_or_delete;

  console.log(data);

  const dataToResource: IGenericResources = {
    selectiveProcess: data?.selective_process_name,
    identification: data?.period_identification,
    isOpen: data?.is_in_resource,
    period: data?.resource_period,
    listItem: listResources || [],
    instruction_to_candidates: data?.instruction_to_candidates,
  };

  if (isMobile)
    return <ResourceDetailMobilePage id={resourceId} {...{ isLoading, dataToResource, isUpdateOrDelete }} />;

  return (
    <MainCard height="100%" title="ÁREA DO CANDIDATO" subtitle="- MEUS RECURSOS">
      <Stack px={['10px', '10px', '10px', '50px', '50px']} gap={10}>
        {data?.instruction_to_candidates && data?.instruction_to_candidates !== '<p><br></p>' && (
          <MessageForUser showIcon={false} mt={5} informationText={data.instruction_to_candidates} />
        )}
        <Stack>
          <TextL>{data?.selective_process_name}</TextL>
          <TextXS>
            <strong>Recurso: </strong> {data?.period_identification}
          </TextXS>
          <TextXS>
            <strong>Período de recurso: </strong>
            {data?.resource_period}
          </TextXS>
        </Stack>
        {data?.resource_by_candidate && data?.resource_by_candidate.length > 0 && (
          <TableCustom
            headers={data?.resource_type_has_question ? headerResources : headerResourcesNoQuestion}
            maxH={500}
            overflowY="auto"
          >
            {data?.resource_by_candidate.map((resources, index) => (
              <Tr key={index}>
                <Td textAlign="center">
                  <TextXS
                    cursor="pointer"
                    onClick={() => {
                      navigate(`/painel/recursos/mostrar-mais/detalhes/${resources.resource_id}`, {
                        state: { periodId: resourceId, resourcePeriod: data?.resource_period },
                      });
                    }}
                    color="colorLink"
                    _hover={{ textDecoration: 'underline', color: 'blue.600' }}
                    transition="all 0.2s"
                    fontWeight="medium"
                  >
                    {resources.resource_code}
                  </TextXS>
                </Td>
                {data?.resource_type_has_question && (
                  <Td textAlign="center">
                    <TextXS>{resources.question || '--'}</TextXS>
                  </Td>
                )}

                <Td textAlign="center">
                  {' '}
                  <TextXS>{resources.resource_created_at || '--'}</TextXS>
                </Td>
                <Td textAlign="center">
                  <Badge
                    borderRadius={4}
                    textAlign="center"
                    lineHeight="normal"
                    p={1}
                    px={2}
                    bg={badgeColor(resources.status)?.bgColor || 'black'}
                    color={badgeColor(resources.status)?.color || 'white'}
                  >
                    {resources.status}
                  </Badge>
                </Td>
                <Td textAlign="center">
                  <Stack direction="row" justifyContent="center" spacing={3}>
                    <TextXS
                      cursor="pointer"
                      ml={1}
                      as="span"
                      onClick={() => {
                        navigate(`/painel/recursos/mostrar-mais/detalhes/${resources.resource_id}`, {
                          state: { periodId: resourceId, resourcePeriod: data?.resource_period },
                        });
                      }}
                      color="colorLink"
                      _hover={{ textDecoration: 'underline', color: 'blue.600' }}
                      transition="all 0.2s"
                      fontWeight="medium"
                    >
                      Detalhes
                    </TextXS>
                    {isUpdateOrDelete && (
                      <TextXS
                        cursor="pointer"
                        as="span"
                        onClick={() => {
                          navigate(`/painel/recursos/mostrar-mais/detalhes/${resources.resource_id}?mode=edit`, {
                            state: { periodId: resourceId, resourcePeriod: data?.resource_period },
                          });
                        }}
                        color="colorLink"
                        _hover={{ textDecoration: 'underline', color: 'blue.600' }}
                        transition="all 0.2s"
                        fontWeight="medium"
                      >
                        Modificar recurso
                      </TextXS>
                    )}
                  </Stack>
                </Td>
              </Tr>
            ))}
          </TableCustom>
        )}

        {data?.is_in_resource && (
          <>
            {resourceData?.data?.resource?.has_exemption && resourceData?.data?.exemptions?.length === 0 ? (
              <></>
            ) : (
              <Stack>
                <TextL>Novo recurso</TextL>
                <TextXS>
                  Para criar um novo recurso,{' '}
                  <Link
                    onClick={() => {
                      navigate(`/painel/recursos/novo-recurso/${resourceId}`);
                    }}
                    color="colorLink"
                  >
                    Clique aqui
                  </Link>
                </TextXS>
              </Stack>
            )}
          </>
        )}
      </Stack>
    </MainCard>
  );
};
export default ResourceSolicitation;
